import { BaseSwiperCarousel } from '@capsicum/common-web';
import { type SurveyMedia } from '@capsicum/features/survey/shared';
import styled from 'styled-components';

export type SurveyAnswerModalProps = {
	innerContainerDimensions?: { height: number; width: number };
	mediaItems: Array<SurveyMedia>;
	mediaType: 'image' | 'video';
};

export const SurveyAnswerModal = ({ mediaItems, mediaType }: SurveyAnswerModalProps) => {
	if (mediaType === 'video') {
		const { url } = mediaItems.find(item => item.mediaType === 'video') || {};

		if (!url) {
			return null;
		}

		return <S.StyledVideo autoPlay controls src={url} />;
	}

	return (
		<S.StoryContainer>
			<BaseSwiperCarousel hasPagination images={mediaItems} testID="" />
		</S.StoryContainer>
	);
};

namespace S {
	export const StoryContainer = styled.div`
		overflow: hidden;
		max-height: 100%;
	`;

	export const StyledVideo = styled.video`
		width: 100%;
		height: 100%;
	`;
}
